/**
 * Centralised Swiggy One journey New Relic events.
 *
 * Covers 4 touchpoints: M2C Halfcard, BullsEye TG, Item Nudge, Savings Corner Nudge.
 * Remove this file in one shot once the release is stable.
 */
import { NEWRELIC_TABLES, recordNREvent } from "@swiggy-private/checkout-core";

export const SWIGGY_ONE_COMPONENT = {
    M2C_HALFCARD: "M2C_HALFCARD",
    BULLS_EYE_TG: "BULLS_EYE_TG",
    ITEM_NUDGE: "ITEM_NUDGE",
    SAVINGS_CORNER: "SAVINGS_CORNER",
} as const;

export const SWIGGY_ONE_STATE = {
    MOUNTED: "MOUNTED",
    ERROR_BOUNDARY: "ERROR_BOUNDARY",
    // data state
    DATA_VALID: "DATA_VALID",
    DATA_INVALID: "DATA_INVALID",
    // hide reasons
    HIDDEN_BY_MODAL: "HIDDEN_BY_MODAL",
    HIDDEN_FREQUENCY_CAPPED: "HIDDEN_FREQUENCY_CAPPED",
    HIDDEN_GRATIFICATION_SHOWN: "HIDDEN_GRATIFICATION_SHOWN",
    HIDDEN_OVERLAY_BLOCKED: "HIDDEN_OVERLAY_BLOCKED",
    // bulls eye tg specific
    PLAN_TYPE_INVALID: "PLAN_TYPE_INVALID",
    NO_BILL_DETAILS_CARD: "NO_BILL_DETAILS_CARD",
    // item nudge specific
    NO_COMMS: "NO_COMMS",
    MODAL_BLOCKING: "MODAL_BLOCKING",
    // savings corner specific
    NO_DATA: "NO_DATA",
} as const;

type Component = (typeof SWIGGY_ONE_COMPONENT)[keyof typeof SWIGGY_ONE_COMPONENT];
type State = (typeof SWIGGY_ONE_STATE)[keyof typeof SWIGGY_ONE_STATE];

const ERROR_BUCKET_MAP: Record<string, string> = {
    TypeError: "type_error",
    ReferenceError: "reference_error",
    SyntaxError: "syntax_error",
    RangeError: "range_error",
    ChunkLoadError: "chunk_load_error",
};

export function getErrorBucket(error?: Error): string {
    const name = error?.name || "";
    return ERROR_BUCKET_MAP[name] ?? (name ? "other_named" : "unknown");
}

export function recordSwiggyOneNREvent(component: Component, state: State, extra?: Record<string, string>): void {
    recordNREvent({
        ...extra,
        eventType: NEWRELIC_TABLES.DEBUG_SWIGGY_ONE_JOURNEY,
        component,
        state,
    });
}
